import { ApiService }           from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { InvoiceModel }         from '../../app-lite/invoices/models/invoice';
import { SessionService }       from '../../app-lite/sessions/session.service';

import InvoiceHtml            from './invoice.html';
import UpdateInvoiceNotesHtml from './update-invoice-notes.html';

export function InvoicesStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'invoice',
    name      : 'app.invoice',
    params    : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null },
      vehicle_id : { squash: true, value: null }
    },
    templateUrl: InvoiceHtml,
    url        : '/:customer_id/:vehicle_id/invoice/:id',
    resolve    : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      customerSources: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer_sources', null, 'customerSources'),
      jobStatus      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/job_status_types', null, 'jobStatus'),
      payment_methods: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/invoice_payment_methods'),
      paymentTerms   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/payment_term_types', null, 'paymentTerms'),
      taxGroups      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups'),
      attachments    : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('invoice/list_all_attachments', $stateParams.id)
          : [],
      credits: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('credit_application_items/invoice_credit_list', [ $stateParams.id, 0, 6 ])
          : [],
      customer: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.customer_id
          ? workshopAPI.get('/customer', $stateParams.customer_id)
          : '',
      defaultTaxGroup: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> =>
        $stateParams.customer_id
          ? workshopAPI.get('/tax_groups/default_for_customer', $stateParams.customer_id)
          : null,
      event: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/invoices/event_for_invoice', $stateParams.id)
          : '',
      inspections: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/invoice/inspection_list', $stateParams.id)
          : [],
      internals: ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> =>
        sessionObjAPI.company().has_dealership
          ? workshopAPI.get('/dealership_setting')
          : null,
      invoice: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/invoice',$stateParams.id)
          : '',
      jobCards: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<Array<InvoiceModel>> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/invoices/job_card_list', $stateParams.id)
          : [],
      quotes: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<Array<InvoiceModel>> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/invoices/quote_list', $stateParams.id).then((invoice : InvoiceModel) => [ invoice ])
          : [],
      payments: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/invoices/payments_for_invoice_list', [ $stateParams.id, 0, 6, 'post_date', 'desc' ])
          : [],
      vehicle: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.vehicle_id
          ? workshopAPI.get('/vehicle/show_any', $stateParams.vehicle_id)
          : ''
    }
  })
  .state({
    controller: 'addInvoiceJobCardNotes',
    name      : 'app.add-invoice-notes',
    params    : {
      invoice_id: { squash: true, value: null }
    },
    templateUrl: UpdateInvoiceNotesHtml,
    url        : '/invoice/:invoice_id/add_invoice_notes',
    resolve    : {
      invoice: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.invoice_id
        ? workshopAPI.get('/invoice',$stateParams.invoice_id)
        : ''
    }
  });
}